import type { IntegrationStatus } from "../../../shared/types";
import { getStatusSummary, statusLabels, statusTone } from "../../utils/status";

interface MetricCardProps {
  label: string;
  value: number | string;
  status: IntegrationStatus;
  subtitle?: string;
  statusLabel?: string;
}

export function MetricCard({ label, value, status, subtitle, statusLabel }: MetricCardProps) {
  return (
    <article className={`metric-card metric-${statusTone[status]}`}>
      <div className="metric-card__topline">
        <span>{label}</span>
        <span>{statusLabel ?? statusLabels[status]}</span>
      </div>
      <strong>{value}</strong>
      <p>{subtitle || getStatusSummary(status)}</p>
    </article>
  );
}
